import { parse as qsParse } from 'qs';
import { LoginLocation } from 'utils/locationState';

/**
 * Pre-fill email fields with something useful if search or router state provides
 * a clue.
 */
export function guessEmail(location: LoginLocation) {
  const fromState = location.state?.formHints?.email;
  const { email: fromSearch } = qsParse(location.search, {
    ignoreQueryPrefix: true,
  });
  return fromState || fromSearch || undefined;
}
